var $7f2ac18ee8d9eab6$exports = {};
$7f2ac18ee8d9eab6$exports = {
    "help": `\u{5E2E}\u{52A9}`,
    "info": `\u{4FE1}\u{606F}`
};


export {$7f2ac18ee8d9eab6$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
